export const TagCategory = {
    EVENT: 'EVENT',
    FAQ: 'FAQ',
    MEDIA: 'MEDIA',
    CHECKIN: 'CHECKIN',
}
